import {
  REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP,
  REDUX_HIDE_SAMPLE_READ_ONLY_POPUP,
  REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP,
  REDUX_SHOW_SAMPLE_READ_ONLY_POPUP,
} from './ActionTypes/ReduxActionTypes'

/** Opens the "Try generating a sample timetable first" popup (SampleReadOnlyModal). */
export const showSampleReadOnlyPopup = () => ({
  type: REDUX_SHOW_SAMPLE_READ_ONLY_POPUP,
})

/** Closes it; the page underneath is left as it was. */
export const hideSampleReadOnlyPopup = () => ({
  type: REDUX_HIDE_SAMPLE_READ_ONLY_POPUP,
})

/** Opens the "sample timetable generation limit reached" modal (SampleGenerationLimitModal). */
export const showSampleGenerationLimitPopup = () => ({
  type: REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP,
})

/** Closes it. */
export const hideSampleGenerationLimitPopup = () => ({
  type: REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP,
})
